<template>
	<div class="contenedor-violines" v-bind:id=violin_id>
		<div>
			<a class="titulo-proyecto" v-if="enlace_proyecto" :href="enlace_proyecto">{{titulo_proyecto}}</a>
			<p class="titulo-proyecto" v-if="!enlace_proyecto && titulo_proyecto">{{titulo_proyecto}}</p>
			<h3 class="titulo-visualizacion" v-if="titulo">{{titulo}}</h3>
			<p class="fecha-actualizacion" v-if="fecha_actualizacion">{{fecha_actualizacion}}</p>
			<p class="instruccional" v-if="instruccional">{{instruccional}}</p>
		</div>
		<div class="tooltip"> 
			<div class="tooltip-contenido">
				<div class="contenedor-boton-cerrar">
				<span class="tooltip-variable"> </span>
					<button class="boton-cerrar-tooltip" @click="cerrarTooltip">
						<img src="@/assets/img/cerrar.svg" alt="Cerrar Tooltip">
					</button>
				</div>
				<p class="tooltip-cifra">120 | <b> 29.3%<b></b></b></p>
			</div>
		</div>
		<svg class="svg-violines">
			<defs></defs>
			<g class="grupo-contenedor-de-violines"></g>
		</svg>
		<div class="violines-notas" :class="{open:notas_open}" v-if="notas">
			<div class="content">
				<div class="contenedor-notas" v-if="texto_notas">
					<p><strong>Notas</strong></p>
					<p>{{texto_notas}}</p>
				</div>
				<div class="contenedor-fuente" v-if="texto_fuente">
					<p><strong>Fuente: </strong>{{texto_fuente}}</p>
				</div>
				<div class="contenedor-descarga" v-if="link_descarga_csv">
					<a class="descargar-datos" :href="link_descarga_csv">
						Descargar datos
					</a>
				</div>
				<div class="contenedor-descarga" v-if="!link_descarga_csv">
					<button class="descargar-datos" :href="link_descarga_csv" @click="descargarCSV">
						Descargar datos
					</button>
				</div>
			</div>
			<button aria-hidden="true" class="summary" @click="notas_open=!notas_open" type="button">
				{{notas_open ? "Menos información": "Más información"}}
			</button>
		</div>
    <div class="violin-footer">
      <PieComponenteLibreria />
    </div>
	</div>
</template>

<script>
	import * as d3 from "d3";
	import downloadCsv from "@/components/graficas/_download_csv.js";
  import PieComponenteLibreria from '@/components/base/PieComponenteLibreria.vue';

	export default {
		name: 'DaiViolin',
    components: {
      PieComponenteLibreria,
    },
		props: {
			violin_id: {
				type: String,
				required: true
			},
			datos: {
				type: Array,
				required: true
			},
			titulo: String,
			instruccional: String,
			titulo_leyenda: String,
			enlace_proyecto: String,
			titulo_proyecto: String,
			texto_fuente: String,
			texto_notas: String,
			link_descarga_csv: String,
			variables: Object,
			fecha_actualizacion: String,
			notas: String,
			titulo_tooltip: String,
			titulo_eje_y: String,
			titulo_eje_x: String,
			bins: {
				type: Number,
				default: () =>  20,
			},
			color_violin: {
				type: String,
				default: () => '#000'
			},
			opacidad_violin: {
				type: Number,
				default: () => .5
			},
			ancho_tooltip: {
				type: Number,
				default: 165
			},
			alto_vis: {
				type: Number,
				default: 500,
			},
			margen: {
				type: Object,
				default: () => ({arriba: 10, abajo: 70, izquierda: 50, derecha: 20})
			},
		},
		watch: {
			datos() {
				this.configurandoDimensionesParaViolin();
				this.creandoViolines();
				this.actualizandoViolines();
			}
		},
		data() {
			return {
				notas_open: false,
				orden_inicial: true,
				zoom_activo: "hidden",
				width: 500,
				height: 300,
			}
		},
		mounted() {
			this.svg = d3.select("#"+this.violin_id+" svg.svg-violines");
			this.grupo_contenedor = this.svg.select("g.grupo-contenedor-de-violines");
			this.texto_y = this.grupo_contenedor.append("text").text(this.titulo_eje_y);
			this.texto_x = this.grupo_contenedor.append("text").text(this.titulo_eje_x);
			this.eje_x = this.grupo_contenedor
				.append("g")
				.attr("class","eje-x");
			this.eje_y = this.grupo_contenedor
				.append("g")
				.attr("class","eje-y");
			this.configurandoDimensionesParaSVG();
			this.configurandoDimensionesParaViolin();
			this.creandoViolines();
			this.actualizandoViolines();
			this.tooltip = d3.select("div#"+this.violin_id)
				.select("div.tooltip");
			this.tooltip.style("visibility","hidden")

			window.addEventListener("resize", this.reescalandoPantalla);
		},
		beforeDestroy(){
			window.removeEventListener("resize", this.reescalandoPantalla);
		},
		methods: {
			configurandoDimensionesParaSVG() {
				this.width = document.getElementById(this.violin_id)
					?.clientWidth ? document.getElementById(this.violin_id)
					.clientWidth - this.margen.izquierda - this.margen.derecha : 300
				this.height = this.alto_vis - this.margen.arriba - this.margen.abajo;
				this.svg.attr("width", this.width + this.margen.izquierda + this.margen.derecha)
					.attr("height", this.height + this.margen.arriba + this.margen.abajo);
				this.grupo_contenedor
					.attr("transform",`translate(${this.margen.izquierda},${this.margen.arriba})`);

			},
			configurandoDimensionesParaViolin() {
				this.escalaY = d3.scaleLinear()
					.domain(d3.extent(this.datos.map((d) => d[this.variables.variable_dist])))
					.range([this.height, 0]);
				let unicos = this.datos.map((d) => d[this.variables.grupos]);
				unicos = unicos.filter((elem, pos) => unicos.indexOf(elem) == pos);
				this.escalaX = d3.scaleBand()
					.range([0, this.width])
					.domain(unicos)
					.padding(0.05); 
				this.histograma = d3.bin()
					.domain(this.escalaY.domain())
					.thresholds(10) 
					.value((d) => d);
				this.data_agrupada = d3.rollup(
					this.datos,
					(d)=> {
						let input = d.map((g) =>  g[this.variables.variable_dist]);
						let bins = this.histograma(input);
						return bins
					},
					(d) => d[this.variables.grupos]
				);
				let numero_maximo = 0;
				for (var i of this.data_agrupada){
					let longuest = d3.max(i[1].map((a) => a.length));
					if (longuest > numero_maximo) { numero_maximo = longuest }
				}
				this.escalaPathX = d3.scaleLinear()
					.range([0, this.escalaX.bandwidth()])
					.domain([-numero_maximo, numero_maximo]);
			},
			creandoViolines() {
				this.grupo_contenedor
					.selectAll(".grupoViolin")
					.remove();
				this.grupos_violines = this.grupo_contenedor.selectAll("myViolin")
					.data(this.data_agrupada)
					.enter()
					.append("g")
					.attr("class", "grupoViolin");
				this.violines = this.grupos_violines.append("path")
					.datum((d) => {return d[1]});
				this.creandoRectangulosOver();

			},
			creandoRectangulosOver() {
				this.grupos_violines.selectAll(".rect-tooltip-violin").remove();
				this.grupos_violines
					.selectAll('rects')
					.data((d) => d[1])
					.enter()
					.append('rect')
					.attr('class', 'rect-tooltip-violin')
					.attr('x', (d) => this.escalaPathX.range()[0])
					.attr('y',(d) => this.escalaY(d.x0) - 0.5 * (this.escalaY(d.x0) -this.escalaY(d.x1)) )
					.attr('height', (d) => this.escalaY(d.x0) -this.escalaY(d.x1))
					.attr('width', (d) => this.escalaPathX.range()[1])
					.style('fill-opacity', .0)
					.on("mouseover", (evento, datum) => {
						
						if(window.innerWidth>768){
							this.mostrarTooltip(evento, datum)
						}
					})
					.on('mouseout', () => {
						if(window.innerWidth>768){
							this.cerrarTooltip()
						}
					})
					.on('mousemove',(evento,datum) => {
						if(window.innerWidth>768){
							this.acomodarTooltip(evento)
						}
					})
					.on("click",(evento,datum)=>this.mostrarTooltip(evento,datum));

			},
			actualizandoViolines() {
				this.grupos_violines
					.attr("transform", (d) => `translate(${this.escalaX(d[0])} ,0)`);
				this.violines
					.style("stroke", "none")
					.style("fill", this.color_violin)
					.style("fill-opacity", this.opacidad_violin)
					.attr("d", 
						d3.area()
							.x0((d)=> this.escalaPathX(-d.length))
							.x1((d) => this.escalaPathX(d.length))
							.y((d) => this.escalaY(d.x0) )
							.curve(d3.curveCatmullRom)
					)
				this.eje_x.attr("transform",`translate(0, ${this.height})`).call(d3.axisBottom(this.escalaX));
				this.eje_x.selectAll("text")
					.attr("transform","rotate(-50)translate(-10,-5)")
					.style("text-anchor","end");
				this.eje_x.select("path").style("opacity",0);
				this.eje_y.call(d3.axisLeft(this.escalaY).ticks(5));
				this.eje_y.selectAll("line")
					.attr("x1",this.width)
					.style("stroke-dasharray","3 2")
					.style("stroke","#999");
				this.eje_y.select("path").style("opacity",0);
				let center_y = ((this.height/2)*-1) - 10;
				let left_x = (this.margen.derecha * -1) - 10;
				this.texto_y
					.style("opacity",.8)
					.attr("transform","rotate(-90)")
					.attr('class', 'titulo-eje')
					.attr("x", center_y)
					.attr("y", left_x);
				this.texto_x
					.style("opacity",.8)
					.attr('class', 'titulo-eje')
					.attr("x",   .5 * this.width)
					.attr("y", this.height + this.margen.arriba + this.margen.abajo - 15)
					.style("text-anchor","middle");
			},
			reescalandoPantalla() {
					this.configurandoDimensionesParaSVG();
					this.configurandoDimensionesParaViolin();
					this.creandoViolines()
					this.actualizandoViolines();
			},
			acomodarTooltip(evento){
				this.tooltip
					.style("left",evento.layerX< .6 * this.width ? (evento.layerX +10)+"px":(evento.layerX-this.ancho_tooltip -10 )+"px" )
					.style("top",evento.layerY+"px")
					.attr("width",this.ancho_tooltip)
					.attr("height", 30)

				this.tooltip
					.style("top",evento.layerY+"px")
			},
			mostrarTooltip(evento,datum){
				this.tooltip.style("visibility","visible")
				this.svg.selectAll(".marcador").remove()
				d3.select(evento.target.parentElement)
					.append('path')
					.attr('d',`M ${this.escalaPathX(-datum.length)},${this.escalaY(datum.x0)} ${this.escalaPathX(-datum.length) - 5},${this.escalaY(datum.x0) + 5} ${this.escalaPathX(-datum.length) - 5},${this.escalaY(datum.x0) - 5}z`)
					.attr('class', 'marcador')
				d3.select(evento.target.parentElement)
					.append('path')
					.attr('d',`M ${this.escalaPathX(datum.length)},${this.escalaY(datum.x0)} ${this.escalaPathX(datum.length) + 5},${this.escalaY(datum.x0) + 5} ${this.escalaPathX(datum.length) + 5},${this.escalaY(datum.x0) - 5}z`)
					.attr('class', 'marcador')
				d3.select(evento.target.parentElement)
					.append('line')
					.attr('class', 'marcador')
					.attr('x1', this.escalaPathX(datum.length))
					.attr('x2', this.escalaPathX(-datum.length))
					.attr('y1', this.escalaY(datum.x0))
					.attr('y2', this.escalaY(datum.x0))
					.style("stroke","#000")
				this.tooltip
					.style("left",evento.layerX< .6 * this.width ? (evento.layerX +10)+"px":(evento.layerX-this.ancho_tooltip -10 )+"px" )
					.style("top",evento.layerY+"px")
					.attr("width",this.ancho_tooltip)
					.attr("height", 30)
				
				let contenido_tooltip=this.tooltip.select("div.tooltip-contenido")
					.style("background","rgba(0, 0, 0,.8)")
					.style("min-width",this.ancho_tooltip +"px")
					.style("border-radius","8px")
					.style("width",this.ancho_tooltip+"px")
					.attr("height",70 )
					.style("padding","0 3px 0 10px");
				
				this.svg.select("button.boton-cerrar-tooltip")
					.on("click",this.cerrarTooltip);
				contenido_tooltip
					.select(".tooltip-variable")
					.text(evento.target.parentElement.__data__[0]);
				
				contenido_tooltip
					.select("p.tooltip-cifra")
					.html(`${datum.length} casos de ${datum.x0} a ${datum.x1 - 1} años (${
						Math.round(1000*datum.length/d3.sum(evento.target.parentElement.__data__[1].map(d=> d.length)))/10
					}%)`)
					.style("margin","0")
					.style("padding","0 0 5px 0")
				
				
				this.tooltip
					.style("height",contenido_tooltip.style("height"))
					.style("width",contenido_tooltip.style("width") )
					.style("top",evento.layerY+"px")	
			},
			cerrarTooltip() {				
				this.svg.selectAll(".marcador").remove()
				this.tooltip.style('visibility', 'hidden')
			},
			descargarCSV() {
				var b = [`${Object.values(this.variables).join(",")}\n`].concat(this.datos.map(d=>Object.values(this.variables).map(col=>d[col]).join(",")+"\n"));
				downloadCsv(new Blob(b, { type: 'text/plain' }), this.titulo.replaceAll(" ", "_"));
			}
		},
		computed: {
			vistaSimplificada() {
				return this.$store.getters.tieneVistaSimplificada;
			},
		}
	}
</script>

<style scoped lang="scss">
	$border-radius-tarjeta:10px;
	.titulo-proyecto{
		padding: 10px 10px 0px 10px;
		text-align: right;
		font-size: 12px;
		display: inherit;
	}
	.titulo-visualizacion{
		font-size: 16px;
		padding: 10px 10px 0;
		margin: 0;
	}
	.fecha-actualizacion {
    font-size: 12px;
    padding: 0 10px;
    margin: 5px 0;
  }
	.instruccional{
		font-size: 12px;
		padding: 0 10px;
		margin: 5px 0;
	}
	div.contenedor-violines {
		font-family: "Montserrat";
		position: relative;
		width: 100%;
		border: solid black 1px;
		border-radius: $border-radius-tarjeta;
	}
  .violin-footer {
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    }
  }
	.violines-notas {
		color: #222;
		.summary {
			height: 30px;
			background:#000;
			color: #fff;
			text-align: center;
			font-size:12px;
			font-weight: 500;
			padding: 4px;
			width: 100%;
			border: solid 1px #000;
			border-radius:0 0 $border-radius-tarjeta $border-radius-tarjeta;
			transition: all .27s ease-in-out;
			&:hover,
			&:focus,
			&:active {
				background-color: #000;
				color: #fff;
			}
		}
		.content {
			max-height: 0;
			overflow: hidden;
			transition: all .33s ease-in-out;
			padding: 0 15px;
			font-size: 12px;
			line-height: 1.3em;
		}
		&.open {
			height: auto;
			.content{
				max-height: 200px;
				padding: 5px 15px;
			}
		}
	}
	.violines-notas {
		.content {
			.contenedor-notas{
				border-top: solid 1px #000;
			}
			.contenedor-fuente{
				border-top: solid 1px rgb(192, 192, 192);
			}
			.contenedor-descarga{
				border-top: solid 1px #000;
				display: flex;
				.descargar-datos{
					cursor: pointer;
					margin: 15px auto;
					font-size: 12px;
					color: #fff;
					background: #000;
					border: none;
					padding: 5px 10px;
					border-radius: 3px;
					text-decoration:none;
					img{
						position: relative;
						top:2px;
						margin-left: 5px;
					}
				}
			}
		}
	}
	// deep in the ocean
	svg::v-deep text {
		font-family: "Montserrat";
	}
	svg.svg-violines::v-deep foreignObject {
		color:#fff;
		font-size: 12px;
		overflow: hidden;
	}
	svg.svg-violines::v-deep .titulo-eje {
		font-size: 12px;
	}
	.contenedor-violines div.tooltip {
		color:#fff;
		font-size: 12px;
		position: absolute;
	 	div.contenedor-boton-cerrar{
			height: auto;
			display: flex;
			width: 100%;
			padding-top:5px;
		}
		.tooltip-variable{
			flex: auto;
			padding-top:5px
		}

		button.boton-cerrar-tooltip{
			background: none;
			border:none;
			padding: 0;
			max-width: 30px;
    		flex: auto;
			@media (min-width: map-get($media-queries-limit, "mobile")) {
				display: none;	
			}
			cursor:pointer;
			img{
				width:23px;
				height: 30px;
				float:right;
			}
		}
	}
</style>
